import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useStore } from '../../store';

function GetTicket() {
  const params = useParams();
  const id = params.id;
  const { getDfrById } = useStore();
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTicket = async () => {
      try {
        setLoading(true);
        const ticketData = await getDfrById(id);
        setTicket(ticketData);
        setError(null);
      } catch (err) {
        setError('Failed to fetch ticket data.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchTicket();
    }
  }, [id, getDfrById]);

  const renderValue = (value) => {
    if (typeof value === 'object' && value !== null) {
      return <pre>{JSON.stringify(value, null, 2)}</pre>;
    }
    return value?.toString() || 'N/A';
  };

  const renderLineItems = (items, title, fields) => {
    if (!items || !items.data || items.data.length === 0) {
      return null;
    }

    const fieldsMap = fields.reduce((acc, field) => {
      acc[field.id] = field.label;
      return acc;
    }, {});

    return (
      <div className="mt-6">
        <h2 className="mb-2 text-xl font-bold">{title}</h2>
        {items.data.map((record, index) => (
          <div key={index} className="p-4 mb-4 border rounded-lg shadow-sm">
            <ul>
              {Object.entries(record).map(([fieldId, valueObj]) => (
                <li key={fieldId} className="py-1">
                  <span className="font-semibold">{fieldsMap[fieldId] || `Field ${fieldId}`}:</span>
                  <span className="ml-2">{renderValue(valueObj.value)}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    );
  };

  const renderTicketData = () => {
    if (!ticket || !ticket.data || ticket.data.length === 0) {
      return <p>No ticket data found.</p>;
    }

    const fieldsMap = ticket.fields.reduce((acc, field) => {
      acc[field.id] = field.label;
      return acc;
    }, {});

    return ticket.data.map((record, index) => (
      <div key={index} className="p-4 mb-4 border rounded-lg shadow-sm">
        <h2 className="mb-2 text-xl font-bold">Record {index + 1}</h2>
        <ul>
          {Object.entries(record).map(([fieldId, valueObj]) => (
            <li key={fieldId} className="py-1">
              <span className="font-semibold">{fieldsMap[fieldId] || `Field ${fieldId}`}:</span>
              <span className="ml-2">{renderValue(valueObj.value)}</span>
            </li>
          ))}
        </ul>
      </div>
    ));
  };

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">Ticket Details</h1>
        <Link to={`/edit/${id}`} className="px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-600">
          Edit
        </Link>
      </div>
      {loading && <p>Loading ticket...</p>}
      {error && <p className="text-red-500">{error}</p>}
      {!loading && !error && (
        <>
          {renderTicketData()}
          {renderLineItems(ticket.laborLineItems, 'Labor Line Items', ticket.laborLineItems?.fields || [])}
          {renderLineItems(ticket.equipmentLineItems, 'Equipment Line Items', ticket.equipmentLineItems?.fields || [])}
        </>
      )}
    </div>
  );
}

export default GetTicket;
